import React from "react";
import "./App.css";
import "./assets/fonts/fonts/fonts.css";
import Application from "./components";
import { UserProvider } from "./context/UserContext";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { CategoryProvider } from "./context/CategoryContext";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Recommended defaults for most apps
        staleTime: 1000 * 60,         // 1 minute
        gcTime: 1000 * 60 * 5,        // 5 minutes
        refetchOnWindowFocus: false,  // don't refetch when tab is focused
      },
    },
  });
  return (
    <div className="layout">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UserProvider>
          <CategoryProvider>
            <CartProvider>
              <Application />
            </CartProvider>
            </CategoryProvider>
          </UserProvider>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={true} /> 
    </QueryClientProvider>
    </div>
  );
}

export default App;
